<div class="page-root">
  <div class="flex">
    <app-login/>
  </div>
</div>
